import { mix, opacify, toHex } from "color2k";

/**
 * proessColor - darken or lighten color.  only supports Hex color for now.
 * @param color 
 * @param type 
 * @returns string (color)
 */

export type ProcessColorType = "light" | "normal" | "dark";

export function processColor(color: string, type: "light" | "normal" | "dark" = "normal") {
  if (!color || (typeof color === "string" && !color.includes("#")) || type === "normal") return color;

  const lightColor = "#fff";
  const darkColor = "rgb(3,3,3)";

  if (type === "light") return toHex(mix(color, opacify(lightColor, .4), .5));
  if (type === "dark") return toHex(mix(color, opacify(darkColor, .4), .5));
}
